<template>
  <div style="width: 100%">
    <div style="padding: 20px">
      <el-form :inline="true" :model="searchForm" size="medium">
        <el-form-item>
          <el-input
            class="w180"
            clearable
            v-model="searchForm.question_question_string"
            placeholder="题目"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="searchQuestion"
            icon="el-icon-search"
            >搜索
          </el-button>
        </el-form-item>
        <el-form-item class="pull-right">
          <el-button type="primary"  icon="el-icon-plus" size="small" @click="addQuestion"
            >添加问题</el-button
          >
          <!-- <el-button type="primary" icon="el-icon-upload" size="small" @click="importQuestion">导入问题</el-button> -->
          <div class="btnInpput">
 <input
            class="file"
            type="file"
            id="files"

            ref="file"
            accept=".xlsx"
            @change="importExcelConfirm"
          />
          <p class="el-icon-upload uploadBtn"  v-loading="excelLoading">导入 Excel 题目</p>
          </div>

        </el-form-item>
      </el-form>

      <el-table class="sortDiv"
                :data="pagedData"
                :stripe="true"
                :current-page.sync="currentPage"
                v-loading="excelLoading">
        <el-table-column
          label="题目"
          prop="question_question_string"
          width="500"
        ></el-table-column>
        <el-table-column label="主题" prop="question_subject"></el-table-column>
        <el-table-column label="年份" prop="question_year"></el-table-column>
        <el-table-column label="等级" prop="question_level"></el-table-column>
        <el-table-column
          label="考点"
          prop="question_competency"
        ></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="edit(scope.row._id.$id)"
              size="mini"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[50, 100, 150]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getExerciseQuestionsByName,
  getExerciseQuestions,
  importCsv
} from '../api/examAdmin'
import { parseQuestionExcel } from '../utils/questionExcel'
export default {
  data () {
    return {
      paginationLoading: false,
      searchForm: {},
      questions: [],
      excelLoading: false,
      currentPage: 1,
      pageSize: 50,
      total: 0,
      // true=浏览模式(服务端分页,questions 仅当前页);false=搜索模式(全部结果,客户端切片)
      serverPaged: true
    }
  },
  computed: {
    pagedData () {
      if (this.serverPaged) {
        return this.questions
      }
      return this.questions.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    }
  },
  created () {
    this.getExerciseQuestions()
  },
  mounted () {
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      if (this.serverPaged) {
        this.getExerciseQuestions()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.serverPaged) {
        this.getExerciseQuestions()
      }
    },
    async importExcelConfirm (event) {
      const file = event.target.files[0]
      let imported = false

      if (!file) {
        return
      }

      this.excelLoading = true

      try {
        const questions = await parseQuestionExcel(file)
        const res = await importCsv(questions)

        if (!res.data || res.data.code !== 0) {
          throw new Error((res.data && res.data.msg) || '服务器导入失败，请稍后重试')
        }

        imported = true
        this.$message({
          message: `成功导入 ${questions.length} 道题目`,
          type: 'success'
        })
      } catch (error) {
        this.$message.error(error.message || 'Excel 导入失败，请检查文件后重试')
      } finally {
        event.target.value = ''
        this.excelLoading = false
      }

      if (imported) {
        this.currentPage = 1
        this.getExerciseQuestions()
      }
    },
    getExerciseQuestions () {
      this.excelLoading = true
      this.serverPaged = true
      getExerciseQuestions({ page: this.currentPage, page_size: this.pageSize }).then((res) => {
        this.excelLoading = false
        this.questions = res.data.data
        // 服务端返回 total 用服务端 total;兜底用当前页长度
        this.total = (res.data.total !== undefined) ? res.data.total : this.questions.length
      })
    },
    searchQuestion () {
      if (!this.searchForm.question_question_string) {
        this.$message.warning('请先输入题目')
      } else {
        getExerciseQuestionsByName(
          this.searchForm.question_question_string
        ).then((res) => {
          if (res.data.code === 0) {
            // 搜索结果为全部匹配项,改用客户端分页展示
            this.serverPaged = false
            this.currentPage = 1
            this.questions = res.data.data
            this.total = this.questions.length
          }
        })
      }
    },
    addQuestion () {
      this.$router.push({
        path: '/questionInfo',
        query: {
          question_id: ''
        }
      })
    },
    edit (id) {
      this.$router.push({
        path: '/questionInfo',
        query: {
          question_id: id
        }
      })
    }
  }
}
</script>

<style scoped>
.uploadBtn{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    padding:9px 10px;
    border-radius: 2px;
    cursor: pointer;
    margin:0;
    margin-left: 10px;
    font-size: 12px;
}
.btnInpput{
position: relative;
    display: inline-block;
    margin-left: 10px;
}
.file{
        position: absolute;
    width: 89px;
    right: 0;
    height: 33px;
    background: red;
    opacity: 0;
    z-index: 999;
    cursor: pointer;
}
</style>
